import React, { lazy, Suspense, useLayoutEffect ,useEffect} from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import { RedirectAs404 } from "../utils/Utils";
import { useStore } from "../store";
import { commonService } from "../_services/common";
import "../pages/admin-catalog.css";

// const Home = lazy(() => import('./routes/Home'));

const Homepage = lazy(() => import("../pages/Homepage"));
const Blank = lazy(() => import("../pages/others/Blank"));
const Sales = lazy(() => import("../pages/Sales"));
const Crypto = lazy(() => import("../pages/Crypto"));
const Invest = lazy(() => import("../pages/Invest"));
const TestPage = lazy(() => import("../pages/TestPage"));
const Profile = lazy(()=>import("../pages/profile/Profile"))

const MeetingHome = lazy(()=>import("../pages/meet/MeetingHome"))
const Meeting = lazy(()=>import("../pages/meet/Meeting"))

//my component
const Product = lazy(() => import("../pages/_products/product"));
const ProductList = lazy(() => import("../pages/_products/ProductList"));
const OrderList = lazy(() => import("../pages/_orders/OrderList"));
const AddProduct = lazy(() => import("../pages/_products/AddProduct"));
const EditProduct = lazy(() => import("../pages/_products/EditProduct"));

const Category = lazy(() => import("../pages/_category/category"));
const City = lazy(() => import("../pages/_city/city"));
const Emirate = lazy(() => import("../pages/_emirate/emirate"));
const License = lazy(() => import("../pages/_license/license"));
const SubLicense = lazy(() => import("../pages/_subLicense/subLicense"));
const SubLicenseGroup = lazy(() => import("../pages/_subLicense/SubLicenseGroup"));
const OfficeType = lazy(() => import("../pages/_office/OfficeType"));
const PackageType = lazy(() => import("../pages/_package/PackageType"));
const FreeZone = lazy(() => import("../pages/_freezone/freezone"));
const AddZone = lazy(() => import("../pages/_freezone/AddZone"));
const EditZone = lazy(() => import("../pages/_freezone/EditZone"));
const Activity = lazy(() => import("../pages/_activity/Activity"));
const ActivityGroup = lazy(() => import("../pages/_activityGroup/ActivityGroup"));
const SubActivity = lazy(() => import("../pages/_activity/SubActivity"));
const NorthernActivity = lazy(() => import("../pages/_activity/NorthernActivity"));
const FreelanceSubLicense = lazy(() => import("../pages/_subLicense/FreelanceSubLicense"));
const FreelanceSubActivity = lazy(() => import("../pages/_activity/FreelanceSubActivity"));

const AddOns = lazy(() => import("../pages/_addons/AddOns"));
const AddAddOns = lazy(() => import("../pages/_addons/AddAddOns"));
const EditAddOns = lazy(() => import("../pages/_addons/EditAddOns"));
const OurBank = lazy(() => import("../pages/_ourBank/OurBank"));
const AddBank = lazy(() => import("../pages/_ourBank/AddBank"));
const EditBank = lazy(() => import("../pages/_ourBank/EditBank"));
const EventList = lazy(()=>import("../pages/_events/EventList"));
const AddEvent = lazy(()=>import("../pages/_events/AddEvent"));
const EditEvent = lazy(()=>import("../pages/_events/EditEvent"));
const ViewEvent = lazy(()=>import("../pages/_events/ViewEvent"));

const CreateArticle = lazy(() => import("../pages/_article/CreateArticle"));
const ListArticle = lazy(() => import("../pages/_article/ListArticle"));
const EditArticle = lazy(() => import("../pages/_article/EditArticle"));
const ViewArticle = lazy(() => import("../pages/_article/ViewArticle"));
const VideoList = lazy(() => import("../pages/_videos/VideoList"));

const CreateBlog = lazy(() => import("../pages/_blog/CreateBlog"));
const EditBlog = lazy(() => import("../pages/_blog/EditBlog"));
const ListBlog = lazy(() => import("../pages/_blog/ListBlog"));
const ViewBlog = lazy(() => import("../pages/_blog/ViewBlog"));
const Faq = lazy(() => import("../pages/_faq/faq"));
const AdList = lazy(() => import("../pages/_ads/AdList"));
const ViewOrder = lazy(() => import("../pages/_orders/ViewOrder"));
const WorkflowList = lazy(() => import("../pages/_workflow/WorkflowList"));
const AddWorkflow = lazy(() => import("../pages/_workflow/AddWorkflow"));
const EditWorkflow = lazy(() => import("../pages/_workflow/EditWorkflow"));
const UserList = lazy(() => import("../pages/_users/UserList"));
const VendorList = lazy(() => import("../pages/_users/VendorList"));
const AgentList = lazy(() => import("../pages/_users/AgentList"));
const UploadSubLicense = lazy(() => import("../pages/_bulkupload/UploadSubLicense"));
const UploadProduct = lazy(() => import("../pages/_bulkupload/UploadProduct"));
const UploadPrice = lazy(() => import("../pages/_bulkupload/UploadPrice"));
const UploadNorthernActivity = lazy(() => import("../pages/_bulkupload/UploadNorthernActivity"));
const UploadFreelanceActivity = lazy(() => import("../pages/_bulkupload/UploadFreelanceActivity"));

const BankApplicationList = lazy(() => import("../pages/_ourBank/ApplicationList"));
const FreelancePrice = lazy(() => import("../pages/_pricing/FreelancePricing"));
const Pricing = lazy(() => import("../pages/_pricing/Pricing"));
const Coupons = lazy(() => import("../pages/_coupon/Coupons"));
const SpecialDeals = lazy(() => import("../pages/_pages/SpecialDeals"));
const DealsBelow7000 = lazy(() => import("../pages/_pages/DealsBelow7000"));
const SpcFreeZone = lazy(() => import("../pages/_pages/SpcFreeZone"));
const BestSelling = lazy(() => import("../pages/_pages/BestSelling"));
const AjmanMediaCity = lazy(() => import("../pages/_pages/AjmanMediaCity"));
const UaqFreeTradeZone = lazy(() => import("../pages/_pages/UaqFreeTradeZone"));
const AjmanFreezone = lazy(() => import("../pages/_pages/AjmanFreezone"));
const CommonlyAsk = lazy(() => import("../pages/_pages/CommonlyAsk"));

// vendor
const HomePageVendor = lazy(() => import("../pages/HomepageVendor"));
const VendorProductList = lazy(() => import("../pages/_products/VendorProductList"));
const Notification = lazy(() => import("../pages/notification/Notification"));
const VendorEditZone = lazy(() => import("../pages/_freezone/VendorEdit"));


const Pages = () => {

  const user = JSON.parse(sessionStorage.getItem('user'));
  const {dispatch} = useStore();
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const adminCatalogRoutes = [
      "/add-on", "/categories", "/emirates", "/freezone", "/license", "/sub-license",
      "/sub-license-group", "/activity-group", "/activity", "/sub-activity", "/northern-activity",
      "/pack-price", "/fl-activity-group", "/fl-sub-activity", "/fl-custom-price", "/events",
      "/workflows", "/bank-partner", "/video-list", "/ads", "/coupons"
    ];
    const isCatalogPage = adminCatalogRoutes.some(
      (route) => pathname === route || pathname.startsWith(`${route}/`)
    );
    document.body.classList.toggle("admin-catalog-page", isCatalogPage);

    return () => document.body.classList.remove("admin-catalog-page");
  }, [pathname]);

  useEffect(()=>{    
    commonService.getCategories().then(val =>{
        dispatch({type:"FETCH_CAT", payload:val});
        console.log('dispatch-cat')
    }).catch(err => console.log(err))    
   },[])

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Suspense fallback={<div/>}>
      {user.code === 44 &&
      <Switch>
        <Route exact path={`/user-list`} component={UserList}></Route>
        <Route exact path={`/agent-list`} component={AgentList}></Route>
        <Route exact path={`/vendor-list`} component={VendorList}></Route>
        <Route exact path={`/orders`} component={OrderList}></Route>
        <Route exact path={`/trash-orders`} component={OrderList}></Route>
        <Route exact path={`/orders/:id`} component={ViewOrder}></Route>
        <Route exact path={`/products`} component={ProductList}></Route>
        <Route exact path={`/add-product`} component={AddProduct}></Route>
        <Route exact path={`/edit-product/:id`} component={EditProduct}></Route>
        <Route exact path={`/product/:id`} component={Product}></Route>
        <Route exact path={`/profile`} component={Profile}></Route>

        <Route exact path={`/categories`} component={Category}></Route>
        <Route exact path={`/cities`} component={City}></Route>
        <Route exact path={`/emirates`} component={Emirate}></Route>        
        <Route exact path={`/license`} component={License}></Route>        
        <Route exact path={`/sub-license`} component={SubLicense}></Route>        
        <Route exact path={`/fl-activity-group`} component={FreelanceSubLicense}></Route>        
        <Route exact path={`/sub-license-group`} component={SubLicenseGroup}/>        
        <Route exact path={`/office-type`} component={OfficeType}></Route>        
        <Route exact path={`/package-type`} component={PackageType}></Route>        
        <Route exact path={`/freezone`} component={FreeZone}></Route>        
        <Route exact path={`/freezone/add`} component={AddZone}></Route>        
        <Route exact path={`/freezone/edit/:id`} component={EditZone}></Route>        
        <Route exact path={`/activity-group`} component={ActivityGroup}></Route>        
        <Route exact path={`/activity`} component={Activity}></Route>        
        <Route exact path={`/sub-activity`} component={SubActivity}></Route>
        <Route exact path={`/fl-sub-activity`} component={FreelanceSubActivity}></Route>
        <Route exact path={`/northern-activity`} component={NorthernActivity}></Route>

        <Route exact path={`/add-on`} component={AddOns}></Route>        
        <Route exact path={`/add-on/add`} component={AddAddOns} />
        <Route exact path={`/add-on/edit/:id`} component={EditAddOns} />
        <Route exact path={`/bank-partner`} component={OurBank} />
        <Route exact path={`/bank-partner/add`} component={AddBank} />
        <Route exact path={`/bank-partner/edit/:id`} component={EditBank} />
        <Route exact path={`/bank-application-list`} component={BankApplicationList} />
        <Route exact path={`/events`} component={EventList} />
        <Route exact path={`/events/add`} component={AddEvent} />
        <Route exact path={`/events/edit/:id`} component={EditEvent} />
        <Route exact path={`/event/:id`} component={ViewEvent} />

        <Route exact path={`/article/:pId`} component={CreateArticle} />
        <Route exact path={`/articles`} component={ListArticle} />
        <Route exact path={`/articles/view/:id`} component={ViewArticle} />
        <Route exact path={`/articles/edit/:id`} component={EditArticle} />
        <Route exact path={`/video-list`} component={VideoList} />
        <Route exact path={`/blogs`} component={ListBlog} />
        <Route exact path={`/blog/add`} component={CreateBlog} />
        <Route exact path={`/blog/view/:id`} component={ViewBlog} />
        <Route exact path={`/blog/edit/:id`} component={EditBlog} />
        <Route exact path={`/faqs`} component={Faq} />
        <Route exact path={`/coupons`} component={Coupons} />
        <Route exact path="/pages/commonly-ask" component={CommonlyAsk} />
        <Route exact path="/pages/special-deals" component={SpecialDeals} />
        <Route exact path="/pages/deals-below-7000" component={DealsBelow7000} />
        <Route exact path="/pages/spc-free-zone" component={SpcFreeZone} />
        <Route exact path="/pages/best-selling" component={BestSelling} />
        <Route exact path="/pages/ajman-media-city" component={AjmanMediaCity} />
        <Route exact path="/pages/uaq-free-trade-zone" component={UaqFreeTradeZone} />
        <Route exact path="/pages/ajman-freezone" component={AjmanFreezone} />
        <Route exact path={`/ads`} component={AdList} />
        <Route exact path={`/workflows`} component={WorkflowList} />
        <Route exact path={`/workflows/add`} component={AddWorkflow} />
        <Route exact path={`/workflows/edit/:id`} component={EditWorkflow} />
        
        <Route exact path={`/upload-north-activities`} component={UploadNorthernActivity} />
        <Route exact path={`/upload-activities`} component={UploadSubLicense} />
        <Route exact path={`/upload-freelance-activities`} component={UploadFreelanceActivity} />
        <Route exact path={`/upload-products`} component={UploadProduct} />
        <Route exact path={`/upload-prices`} component={UploadPrice} />
        <Route exact path={`/pack-price`} component={Pricing} />
        <Route exact path={`/fl-custom-price`} component={FreelancePrice} />
        <Route exact path={`/notifications`} component={Notification}></Route>
        <Route exact path={`/update-zone/:id`} component={VendorEditZone}></Route>
        <Route exact path={`/meet`} component={MeetingHome}></Route>
        <Route exact path={`/meeting/:id`} component={Meeting}></Route>


        {/*Dashboards*/}
        <Route exact path={`/crypto`} component={Crypto}></Route>
        <Route exact path={`/sales`} component={Sales}></Route>
        <Route exact path={`/invest`} component={Invest}></Route>
        <Route exact path={`/_blank`} component={Blank}></Route>
        <Route exact path={`/test-page`} component={TestPage}></Route>       

        <Route exact path={`/`} component={Homepage}></Route>
        <Route component={RedirectAs404}></Route>
      </Switch>}


      {user.code === 33 &&
      <Switch>
        <Route exact path={`/notifications`} component={Notification}></Route>
        <Route exact path={`/products`} component={VendorProductList}></Route>
        <Route exact path={`/add-product`} component={AddProduct}></Route>
        <Route exact path={`/edit-product/:id`} component={EditProduct}></Route>
        <Route exact path={`/update-zone`} component={VendorEditZone}></Route>
        <Route exact path={`/product/:id`} component={Product}></Route>
        <Route exact path={`/profile`} component={Profile}></Route>
        <Route exact path={`/orders`} component={OrderList}></Route>
        <Route exact path={`/trash-orders`} component={OrderList}></Route>
        <Route exact path={`/orders/:id`} component={ViewOrder}></Route>
        <Route exact path={`/`} component={HomePageVendor}></Route>
        <Route component={RedirectAs404}></Route>

      </Switch>}
    </Suspense>
  );
};
export default Pages;
